import React, { useState } from 'react';
import { Modal, Button, Select, Tooltip, Typography, Form, Input, Row } from 'antd';
import { useHistory } from 'react-router-dom';
import { createMulti } from '../../../lib/api/flow-api';
import { UploadFilesStep } from '../upload/UploadFilesStep';
import { Batch, Algorithm } from '../../../types';
import { CONFIG } from '../../../config/Config';
import { ModalTitle } from '../../../components/text/Titles';

const { Text } = Typography;
const { Option } = Select;

type Props = {
  visible: boolean;
  onClose: () => any;
  algorithm: Algorithm;
};
const CreateMultiflow = (props: Props) => {
  const { visible, onClose, algorithm } = props;

  const history = useHistory();

  const [batchUploadReports, setBatchUploadReports] = useState<Batch[]>([]);
  const [flowName, setFlowName] = useState<null | string>(null);
  const [name, setName] = useState<null | string>(null);
  const [step, setStep] = useState<number>(0);
  const [isCreating, setCreating] = useState(false);

  const onFlowChange = (value: string) => {
    setFlowName(value);
  };

  const goToUpload = async () => {
    setStep(1);
  };

  const onSubmit = async () => {
    if (!flowName || !name) return;

    setCreating(true);

    const flow = await createMulti(name, flowName, CONFIG.multiflow.customer, { fields: [] }, batchUploadReports);

    history.push(`/flows/${algorithm.id}/${flow.id}`);
    onModalClose();

    setCreating(false);
  };

  const onModalClose = async () => {
    setName(null);
    setFlowName(null);
    setStep(0);

    onClose();
  };

  const nextButtonIsDisabled = () => {
    if (step === 0) {
      return !flowName || flowName.length === 0 || !name || name.length === 0;
    } else if (step === 1) {
      return isCreating || !batchUploadReports || batchUploadReports.length === 0;
    }
    return false;
  };

  return (
    <Modal
      maskClosable={false}
      visible={visible}
      title={<ModalTitle>New Multi-Model flow</ModalTitle>}
      onCancel={() => onModalClose()}
      footer={
        step === 0 ? (
          <div>
            <Button type="default" onClick={() => onModalClose()}>
              Cancel
            </Button>
            <Tooltip title={nextButtonIsDisabled() ? 'Choose a name and select a flow name before continuing.' : ''}>
              <Button
                style={{ marginLeft: '10px' }}
                type="primary"
                onClick={goToUpload}
                disabled={nextButtonIsDisabled()}>
                Next
              </Button>
            </Tooltip>
          </div>
        ) : (
          <div>
            <Button type="default" onClick={() => onModalClose()}>
              Cancel
            </Button>
            <Tooltip title={nextButtonIsDisabled() ? 'Upload at least 1 document.' : ''}>
              <Button
                type="primary"
                onClick={onSubmit}
                style={{ marginLeft: '10px' }}
                disabled={nextButtonIsDisabled()}>
                Analyze
              </Button>
            </Tooltip>
          </div>
        )
      }>
      {step === 0 ? (
        <div>
          <Text className={'descriptive-title'} style={{ fontSize: '14px' }}>
            This proces will create a new multi-model flow. Choose a name and select the flow to analyse your documents
            and upload documents you would like to process.
          </Text>

          <Row style={{ marginTop: '16px' }}>
            <Form layout={'vertical'}>
              <Form.Item label="Name">
                <Input value={name || undefined} onChange={event => setName(event.target.value)} />
              </Form.Item>
              <Form.Item label="Flow name">
                {CONFIG.multiflow.definitions && (
                  <Select style={{ minWidth: 300 }} value={flowName || undefined} onChange={onFlowChange}>
                    {CONFIG.multiflow.definitions.map(def => (
                      <Option key={def.name} value={def.name}>
                        {def.name}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Form>
          </Row>
        </div>
      ) : (
        <UploadFilesStep
          batchUploadReports={batchUploadReports}
          setBatchUploadReports={setBatchUploadReports}
          getPresignedParams={{ customer: CONFIG.multiflow.customer, flowName: flowName }}
          getPresignedUrl={'/api/generate-presigned-urls'}
        />
      )}
    </Modal>
  );
};

export default CreateMultiflow;
